import Icon from "@material-ui/icons/SpeakerNotesOff";
import NotTakingList from "./NotTakingList";
import NotTakingCreate from "./NotTakingCreate";
import NotTakingEdit from "./NotTakingEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "notTakingStudents",
  create: NotTakingCreate,
  list: NotTakingList,
  edit: NotTakingEdit,
  icon: Icon,
};
